const PartialFailureicon = () => {
    return (
        <div className={'partials PartialSuccessIcon'}>
            <span className="bg-red-600 mb-10 verifiedIconContainer">
                <span className={"icon icon-x text-white text-9xl"}></span>
            </span>
        </div>
    )
}

export default PartialFailureicon;